import { EmpEnvironment } from 'src/app/core/models/env.model';

export const environment: EmpEnvironment = {
  production: false,
  baseUrl: 'https://esmart.energysalesengine.com',
  apiUrl: 'https://esmart.energysalesengine.com/api',
  empApi: 'https://www.energymarketprice.com/EMPAPI',
  offersApi: 'https://offers.energysalesdirect.com/api',
  solutionsApiUrl: 'https://www.energymarketprice.com/EMPAPI/MenuQas',
  cacheHttpGet: false
};
